module.exports = __webpack_public_path__ + "media/Kelsey_Murphy.740aaf9e.mp4";